


















































































































































import CreateDialog from '@/components/CreateDialog.vue'
import Avatar from '@/components/Avatar.vue'
import { Agency } from '@/api/Agency/agency.interface'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencies, createAgency } from '@/api/Agency/agency.api'
import { required, email } from '@/utils/validators'
import PhoneTextField from '@/components/PhoneTextField.vue'
import { VueForm, SelectItem } from '@/utils/interfaces'
import { getServices } from '@/api/Services/services.api'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { editMixin } from '@/utils/mixins/editMixin'
import mixins from 'vue-typed-mixins'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    appAvatar: Avatar,
    appAutocomplete: Autocomplete,
    PhoneTextField: PhoneTextField,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      loading: false,
      rules: {
        required: (v: string | number) =>
          required(v) || this.$t('field-required'),
        email: (v: string) => email(v) || this.$t('must-be-valid-email'),
      },
      crud: {} as Agency,
      defaultCrud: {
        name: '',
        description: '',
        email: '',
        phone: '+1',
        services: [],
        image: '' as string | File,
        address: {
          address_1: '',
          address_2: '',
        },
        child_amount: 0,
        unlimited_childs: false,
        can_has_agents: false,
        can_has_subagents: false,
        cid: '',
      },
      getAgencies,
      servicesLoading: false,
      services: [] as SelectItem[],
    }
  },
  computed: {
    agency(): Agency {
      return this.$store.getters.agency || {}
    },
    src(): string {
      try {
        const image = URL.createObjectURL(this.crud.image)
        return image
      } catch (error) {
        return ''
      }
    },
    themeBackground() {
      if (this.$vuetify.theme.dark) {
        return 'rgba(30,30,30,0.8)'
      } else return 'rgba(255,255,255,0.8)'
    },
  },
  methods: {
    async onSuccess(): Promise<void> {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        if (this.crud.uuid === this.$store.getters.agency.uuid) {
          delete this.crud.services
        }
        const response = await createAgency(this.crud, 'image')
        if (response.status === 200 || response.status === 201) {
          this.$emit('new-agency', response.data)
          this.$emit('input', false)

          setTimeout(() => {
            this.resetCrud()
            ;(this.$refs.form as VueForm).resetValidation()
          }, 500)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    this.servicesLoading = true
    try {
      const response = await getServices()
      this.services = response.data.results
        .filter(
          service =>
            service.active &&
            this.$store.getters.profile.services.includes(service.name),
        )
        .map(item => ({
          text: this.$t(item.name) as string,
          value: item.name,
        }))
    } finally {
      this.servicesLoading = false
    }
  },
})
